module.exports = __webpack_public_path__ + "img/组 128@2x.15bd4025.png";